import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useEffect } from 'react';
import { Spacer, FieldSet, Label, FormHelp, Flex, Adornment, Input, AdornedInput, StyledInput } from '@zillow/constellation';
import styled from 'styled-components';
import { useFormContext, useFormState } from 'react-hook-form';
import { FieldConfig } from './MortgageCalculator.utils.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';

var StyledAmountAdornedInput = /*#__PURE__*/styled(AdornedInput).withConfig({
  componentId: "sc-12w0tx6-0"
})(["", "{border-top-right-radius:0;border-bottom-right-radius:0;border-right-width:0;}flex:1;"], StyledInput);
var StyledPercentAdornedInput = /*#__PURE__*/styled(AdornedInput).withConfig({
  componentId: "sc-12w0tx6-1"
})(["", "{border-top-left-radius:0;border-bottom-left-radius:0;}flex:0.5;", ""], StyledInput, function (_ref) {
  var percentDecimals = _ref.percentDecimals;
  return "\n        // 2 left digits, % adornment, 32px adornment padding + percent decimals in em\n        max-width: calc(" + (percentDecimals + 3) + "em + 32px);\n    ";
});

/**
 *
 */
function DownPaymentField() {
  var _proxyFormState$error, _proxyFormState$error2;
  var form = useFormContext();
  var proxyFormState = useFormState();
  var error = (proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[FieldConfig.downPayment.name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message) || (proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error2 = proxyFormState.errors[FieldConfig.downPaymentPercent.name]) === null || _proxyFormState$error2 === void 0 ? void 0 : _proxyFormState$error2.message);
  var fieldAmount = form.register(FieldConfig.downPayment.name, FieldConfig.downPayment.config);
  var fieldPercent = form.register(FieldConfig.downPaymentPercent.name, FieldConfig.downPaymentPercent.config);
  var amountInputRef = useRef(null);
  var formatAmount = commaSeparateNumber;

  // Format on mount
  useEffect(function () {
    if (formatAmount) {
      var defaultAmountValue = form.getValues(fieldAmount.name);
      if (defaultAmountValue) {
        amountInputRef.current.value = formatAmount(defaultAmountValue);
      }
    }
  }, []);
  return /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(FieldSet, {
    legend: /*#__PURE__*/React.createElement(Label, {
      htmlFor: "downPaymentAmount"
    }, "Down Payment"),
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0"))
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(StyledAmountAdornedInput, {
    error: Boolean(error),
    leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, "$"),
    input: /*#__PURE__*/React.createElement(Input, _extends({
      id: "downPaymentAmount"
    }, fieldAmount, {
      ref: function ref(el) {
        amountInputRef.current = el;
        fieldAmount.ref(el);
      },
      onInput: formatAmount ? function (e) {
        e.target.value = formatAmount(e.target.value);
      } : undefined,
      autoComplete: "off"
    }))
  }), /*#__PURE__*/React.createElement(StyledPercentAdornedInput, {
    error: Boolean(error),
    rightAdornment: /*#__PURE__*/React.createElement(Adornment, null, "%"),
    input: /*#__PURE__*/React.createElement(Input, _extends({}, fieldPercent, {
      autoComplete: "off"
    }))
  }))));
}

export { DownPaymentField as default };
